import { sixHoursDate } from "../utils/Dates.utils";
import { setCookieWithConsent } from "../utils/consentGatedCookies";

/**
 * Las cookies de medición de atribución (click-ids, utm_*, tid, ucc,
 * entryPage, referrerUrl, gtf_campaign) son de categoría necesaria y se
 * escriben en el acto, sin esperar al banner. Solo la analítica de identidad
 * (visitor_id, session_id, user_id) espera al consentimiento de "analytics";
 * hasta entonces queda en sessionStorage y `getCookie` la sigue devolviendo.
 * Ver consentGatedCookies.
 */
export function setCookie(
  name: string,
  _value: string | null,
  _expires: Date = sixHoursDate
) {
  setCookieWithConsent(name, _value, _expires);
}
